import type { SessionManager } from './SessionManager.js'
import type { SessionInfo } from '../types/index.js'

/**
 * Gestionnaire de session pour le mode borne (Altazion Device Shell).
 *
 * Le browser embarqué gère intégralement les cookies de session.
 * Le SDK n'a pas à intervenir : fetch avec credentials:'include' suffit
 * pour que les cookies soient transmis automatiquement.
 *
 * Cette implémentation est un no-op intentionnel.
 */
export class KioskSessionManager implements SessionManager {
  async initialize(): Promise<SessionInfo | null> {
    // Le browser embarqué est responsable de la session.
    // Aucune action requise côté SDK.
    return null
  }

  async onSessionExpired(): Promise<void> {
    // Le browser embarqué gère le renouvellement de session.
    // Aucune action requise côté SDK.
  }
}
